import './plp-content-injection.css';

/* eslint-disable no-param-reassign */
export default (element, data) => {
  const { showOnAllPages } = data;
  const init = () => {
    window.addEventListener('productCardsRendered', () => {
      setTimeout(() => {
        const currentUrl = new URL(window.location.href);
        const pageParamArray = [...currentUrl.searchParams.entries()].find(
          ([key]) => key.includes('page'),
        );
        const pageParam = (pageParamArray && pageParamArray[1]) || '';

        if (typeof injectMarketingCards === 'function') {
          injectMarketingCards({ pageParam });
        }

        if (typeof injectSections === 'function') {
          injectSections({ pageParam });
        }
      }, 300);
    });
    window.addEventListener('resize', adjustHeight);
  };

  const adjustHeight = () => {
    let productCard = document.querySelector(
      '.nosto-product-grid .nosto-product-card',
    );

    let productCardImage = false;

    if (!productCard) {
      productCard = document.querySelector(
        '[data-section="product-grid"] .product-card',
      );
      productCardImage = data.layout.isAboveBreakpoint('lg')
        ? productCard.querySelector('.image')
        : productCard.querySelector('.image');
    } else {
      productCardImage = data.layout.isAboveBreakpoint('lg')
        ? productCard.querySelector('.desktop-image')
        : productCard.querySelector('.product-images img');
    }

    if (!productCard) return; // if product card does not exist, exit function

    const productCardChildElements = productCard.children;
    let productCardHeight = 0;
    [...productCardChildElements].forEach((el) => {
      productCardHeight += el.clientHeight;
    });

    if (!productCardImage) return;

    const productCardImageHeight = productCardImage.clientHeight;

    const allMarketingCards = document.querySelectorAll(
      '[data-single-marketing-card]',
    );

    allMarketingCards.forEach((marketingCard) => {
      const marketingCardContent = marketingCard.querySelector(
        '.marketing-card__content',
      );

      if (marketingCardContent) {
        const mCardImage = marketingCard.querySelector('img');

        if (mCardImage) {
          if (marketingCard.classList.contains('marketing-card--true')) {
            marketingCard.style.height = `${productCardHeight}px`;
          } else {
            marketingCard.style.height = `${productCardImageHeight}px`;
          }
        }
      }
    });
  };

  const injectMarketingCards = ({ pageParam }) => {
    const allMarketingCards = document.querySelectorAll('.marketing-card');
    allMarketingCards.forEach((marketingCard) => {
      marketingCard.remove();
    });

    if (pageParam && !showOnAllPages) {
      return;
    }
    const marketingCardTemplates = document.querySelectorAll(
      '[data-marketing-card]',
    );

    let firstArticle = document.querySelector(
      '#nosto-collection-target article',
    );

    if (!firstArticle) {
      firstArticle = document.querySelector(
        '[data-section="product-grid"] article',
      );
    }

    const collectionContainer = firstArticle.parentElement;
    const productCards = collectionContainer.querySelectorAll('article');

    let position;
    marketingCardTemplates.forEach((template, index) => {
      // eslint-disable-next-line
      position = data.layout.isAboveBreakpoint('lg')
        ? parseInt(template.dataset.marketingCard, 10)
        : parseInt(template.dataset.marketingCardMobile, 10);

      position -= index + 1;

      const clone = template.content.cloneNode(true);
      const productNode = productCards[position];
      // eslint-disable-next-line
      collectionContainer.insertBefore(clone, productNode);
    });
    adjustHeight();
  };

  const injectSections = ({ pageParam }) => {
    const sectionsToInject = Array.from(
      document.querySelectorAll('[data-editorial-section]'),
    ).filter((section) => section.dataset.editorialSection !== '0');

    if (pageParam && !showOnAllPages) {
      sectionsToInject.forEach((section) => {
        section.classList.add('!hidden');
      });
    } else {
      let firstArticleInGrid = document.querySelector(
        '#nosto-collection-target article',
      );

      if (!firstArticleInGrid) {
        firstArticleInGrid = document.querySelector(
          '[data-section="product-grid"] article',
        );
      }
      const collectionContainer = firstArticleInGrid.parentElement;

      sectionsToInject.forEach((section) => {
        collectionContainer.appendChild(section);
        section.classList.remove('hidden', '!hidden');
        section.classList.add('!opacity-100');
      });
    }
  };

  init();
};
